import { Component } from '@angular/core';

@Component({
    selector: 'app-track-my-appointment',
    templateUrl: './track-my-appointment.component.html',
    styleUrl: './track-my-appointment.component.scss'
})
export class TrackMyAppointmentComponent {

}
